export default function (date?: Date) {
  const formatLong = useDateFormat(date, 'MMMM D, YYYY')
  const formatShort = useDateFormat(date, 'MMM D, YYYY')
  const nowFormat = useDateFormat(useNow(), 'YYYY-MM-DD HH:mm:ss')

  return {
    formatLong,
    formatShort,
    nowFormat
  }
}
